/**
 * ImpersonationBanner — Süperadmin bir merchant paneline tek-tık geçtiğinde
 * ekranın en üstünde beliren sarı şerit.
 *
 * `useAuth().session.impersonated_by` dolu olduğu sürece görünür. "Çık"
 * tıklanınca `/api/auth/stop-impersonate` çağrılır — tenant cookie temizlenir,
 * admin kendi `admin_access_token` cookie'si sayesinde hâlâ oturum açıktır,
 * bu yüzden admin paneline (`ADMIN_DASHBOARD_PATH`) yönlendirilir.
 */
import { useState } from "react";
import { ShieldAlert, LogOut } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ADMIN_DASHBOARD_PATH } from "@/lib/admin-path";

export default function ImpersonationBanner() {
    const { session } = useAuth();
    const [busy, setBusy] = useState(false);

    const imp = session && session !== false ? session.impersonated_by : null;
    if (!imp) return null;

    const tenantName = session?.tenant?.company_name || session?.tenant?.site_domain || "merchant";

    const handleExit = async () => {
        if (busy) return;
        setBusy(true);
        try {
            await api.post("/auth/stop-impersonate");
        } catch { /* non-blocking */ }
        // Full nav → tarayıcı admin_* cookie'leriyle admin paneline düşer.
        window.location.assign(ADMIN_DASHBOARD_PATH);
    };

    return (
        <div
            className="sticky top-0 z-40 bg-yellow-100 text-yellow-950 border-b border-yellow-300"
            data-testid="impersonation-banner"
        >
            <div className="max-w-[1400px] mx-auto h-10 px-5 md:px-8 flex items-center justify-between gap-3 text-[12.5px]">
                <div className="flex items-center gap-2 min-w-0">
                    <ShieldAlert className="h-4 w-4 shrink-0" strokeWidth={2} />
                    <span className="truncate">
                        <b className="font-semibold">{tenantName}</b> olarak bakıyorsun ·
                        <span className="opacity-80 ml-1">
                            yönetici <code className="font-mono text-[11px]">{imp.email}</code>
                        </span>
                    </span>
                </div>
                <button
                    type="button"
                    onClick={handleExit}
                    disabled={busy}
                    className="shrink-0 inline-flex items-center gap-1 rounded-md border border-yellow-400/60 bg-yellow-200/60 hover:bg-yellow-200 px-2.5 py-1 text-[11.5px] font-medium transition-colors disabled:opacity-60"
                    data-testid="impersonation-exit"
                >
                    <LogOut className="h-3.5 w-3.5" strokeWidth={2} />
                    {busy ? "Çıkılıyor…" : "Çık"}
                </button>
            </div>
        </div>
    );
}
